import React from 'react'
import { useTheme } from '../../../middleware/ThemeContext';
import { DashboardCard } from './OutstandingBalance';
import CardIconHeader from './Components/CardIconHeader';
import StyledText from '../../../components/StyledComponents/StyledText';
import BriefcaseIcon from '../../../assets/icons/BreifcaseIcon';
import BriefcaseCollectionIcon from '../../../assets/icons/BriefcaseCollectionIcon';

const MembershipDuesCollected = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader 
            icon={<BriefcaseCollectionIcon color={theme.CorporateTheme.colors.count} /> }
            title='Membership Dues Collected'
            count="$42,890.00"
            iconBgColor='rgba(255, 109, 65, 0.12)'
        />
        <hr />
        <StyledText
            fontSize='14px'
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.blueberry}
            fontStyle='italic'
            style={{ textAlign: 'right' }}
        >
            +12% from last month
        </StyledText>
    </DashboardCard>
  )
}

export default MembershipDuesCollected